import { animated, UseTransitionProps } from '@react-spring/web'
import styled from 'styled-components'

type Direction = 'forward' | 'backward'

export const getSlideAnimation = (direction: Direction): UseTransitionProps => {
  return {
    from: {
      position: 'absolute',
      opacity: 0,
      transform: direction === 'forward' ? 'translateX(25%)' : 'translateX(-25%)',
    },
    enter: {
      position: 'absolute',
      opacity: 1,
      transform: 'translateX(0)',
    },
    update: {
      position: 'relative',
    },
    leave: {
      opacity: 0,
      transform: direction === 'forward' ? 'translateX(-25%)' : 'translateX(25%)',
    },
  }
}

export const getFadeAnimation = () => {
  return {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  }
}

export const TransitionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const AnimationWrapper = styled(animated.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  will-change: opacity, transform;
`
